import { render } from "./EcommerceLayout.vue?vue&type=template&id=213fc048&scoped=true"
import script from "./EcommerceLayout.vue?vue&type=script&lang=js"
export * from "./EcommerceLayout.vue?vue&type=script&lang=js"

import "./EcommerceLayout.vue?vue&type=style&index=0&id=213fc048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213fc048"]])

export default __exports__